// extracted by mini-css-extract-plugin
export var backdropBlur = "_ic-0";
export var contentCard = "_ic-5";
export var frame = "_ic-2";
export var image = "_ic-4";
export var imagePane = "_ic-3";
export var modal = "_ic-1";